import { IconName, library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleXmark,
  faPhoneFlip,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gsap } from "gsap";
import { useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import { lgDown, mdDown, smDown, xlDown, xsDown } from "../utils/responsive";
import {
  ParagraphWithBorder,
  WrapperContainer,
  imgbaseUrl,
} from "./SliderItem";

library.add(faCircleXmark, faUsers, faPhoneFlip);

const Container = styled(WrapperContainer)`
  padding: 48px 12px;
`;

const ColWrapper = styled.div`
  display: flex;
  margin: 0 -12px 24px;
  ${mdDown({
    flexDirection: "column",
  })};
`;

const Col = styled.div`
  padding: 0 12px;
  height: 624px;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  ${xlDown({
    height: 546,
  })};
  ${lgDown({
    height: 586,
  })};
  ${mdDown({
    width: "100%",
  })};
`;

const Left = styled(Col)`
  opacity: 0;
  transform: translateY(100%);
  ${mdDown({
    height: 696,
  })};
  ${smDown({
    height: 516,
  })};
  ${xsDown({
    height: "auto",
  })};
`;

const Right = styled(Col)`
  height: auto;
  opacity: 0;
  transform: translateY(100%);
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-size: 3rem;
  margin-bottom: 24px;
  ${lgDown({
    fontSize: "calc(1.425rem + 2.1vw)",
  })}
`;

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
`;

const StyledParagraph = styled(Paragraph)`
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
`;

const Section = styled.div`
  margin-bottom: 48px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-bottom: 16px;
  ${lgDown({
    fontSize: "calc(1.35rem + 1vw)",
  })}
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 48px;
`;

const GridItem = styled.div`
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
`;

const About = () => {
  const tabDescs = [
    {
      firstDesc:
        "WALLSTREET Microfinance Limited is currently capitalized by Mr. Kwame Atta Acheampong, a business executive and Mr. William Kuffour Bonsu a banker and a Business Executive who is currently the Managing Director. The company will explore other investment possibilities to enhance its sustainability while contributing to poverty reduction in the country. ",
      secondDesc:
        "WALLSTREET Microfinance was started with an initial paid-up capital of GH¢250,000 in the form of equity. This has been increased to GHS 2,000,000 through additional share issue to existing shareholders and transfers from income surplus. Our paid-up capital of GH¢ 2,000,000 is contributed by Mr. Kwame Atta Acheampong (60%) and Mr. William Kuffour Bonsu (40%).",
    },
    {
      firstDesc:
        "WALLSTREET Microfinance Limited’s mission is to harness human resource and employ robust technology in the provision of timely and customized financial services aimed at increasing customer enthusiasm. The company seeks to achieve this by increasing shareholders value, exceeding stakeholder and client expectations and meeting our corporate social responsibilities. This will be done within the central bank’s regulatory framework and the laws of the country.",
      secondDesc: `WALLSTREET Microfinance Limited has the objective of supporting micro and small enterprises to expand and sustain their businesses while increasing their incomes. The mission would be achieved through the following:`,
    },
    {
      firstDesc:
        "Our vision is to be among the top five micro finance institutions in the country within the next five years. This will be the result of making financial services more customer focused. Our vision is to position the company as one of the leading Ghanaian microfinance institutions with a branch synergy across the country on a common technological platform.",
      secondDesc:
        "The company wishes to become an industry player to be reckoned with in the private sector, recognized as driving the growth and consequently the economic development of our economy.",
    },
  ];

  const rightEl = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const rightTween = gsap.to(rightEl.current, {
      opacity: 1,
      y: 0,
      delay: 0.3,
      duration: 0.3,
      scrollTrigger: {
        trigger: rightEl.current,
        start: "top-=150% center",
      },
    });

    return () => {
      rightTween.scrollTrigger?.kill();
    };
  }, []);

  return (
    <Container>
      <GridWrapper ref={rightEl}>
       

        <GridItem>
          <ParagraphWithBorder>Our Mission</ParagraphWithBorder>
          <SectionTitle>Mission</SectionTitle>
          <StyledParagraph>{tabDescs[1].firstDesc}</StyledParagraph>
          <StyledParagraph>{tabDescs[1].secondDesc}</StyledParagraph>
        </GridItem>

        <GridItem>
          <ParagraphWithBorder>Our Vision</ParagraphWithBorder>
          <SectionTitle>Vision</SectionTitle>
          <StyledParagraph>{tabDescs[2].firstDesc}</StyledParagraph>
          <StyledParagraph>{tabDescs[2].secondDesc}</StyledParagraph>
        </GridItem>
        <GridItem>
          <ParagraphWithBorder>About Us</ParagraphWithBorder>
          <SectionTitle>Shareholding Structure</SectionTitle>
          <StyledParagraph>{tabDescs[0].firstDesc}</StyledParagraph>
          <StyledParagraph>{tabDescs[0].secondDesc}</StyledParagraph>
        </GridItem>
      </GridWrapper>

      {/* ✅ New Bulleted Section */}
      <Section>
        <SectionTitle>How We Achieve Our Mission</SectionTitle>
        <StyledParagraph>
          WALLSTREET Microfinance Limited supports micro and small enterprises by:
        </StyledParagraph>
        <ul style={{ paddingLeft: "1.25rem", marginTop: "12px", lineHeight: "1.6" }}>
          <li>
            Making working capital readily accessible to viable micro and small enterprises.
          </li>
          <li>
            Supporting young entrepreneurs with financially viable business propositions in starting and or expanding their businesses.
          </li>
          <li>
            Building the capacity of groups, market associations, and individuals in record keeping and basic financial literacy.
          </li>
          <li>
          Testing realistic approaches to loans administration; and enhancing the ability of clients in the productive use of such credit with/without collateral security.  This would be achieved through incentive schemes, such as peer pressure and joint liability and loan insurance approaches
          </li>
          <li>
          Putting in place effective controls to reduce fraud and loan default.
          </li>
        </ul>
      </Section>
    </Container>
  );
};

export default About;
